import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider, applyTheme, initTheme, registerMessages, applyTenantBrand } from "@iga/ui";
import "@iga/ui/styles.css";
import { App } from "./App";
import { en } from "./i18n/en";
import { da } from "./i18n/da";

// Theme before the first paint (no light flash). ?theme=light|dark forces one (screenshots); otherwise the stored preference / OS setting.
const forced = new URLSearchParams(window.location.search).get("theme");
if (forced === "light" || forced === "dark") applyTheme(forced); else initTheme();
// Product default brand until the tenant's own branding is known (App.tsx applies it when the API exposes it).
applyTenantBrand({});
registerMessages("en", en);
registerMessages("da", da);

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
